import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../../store/authStore";
import { DEFAULT_AVATAR_BG, useSettingsStore } from "../../store/settingsStore";
import { fetchAvatarUrl } from "../../utils/apiUtils";

const sameUser = (a, b) => {
    const left = String(a || "").trim().toLowerCase();
    const right = String(b || "").trim().toLowerCase();
    return Boolean(left && right && left === right);
};

const resolveAvatarUrl = (url) => {
    const value = String(url || "").trim();
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return value;
    const base = String(import.meta.env.VITE_BACKEND_URL || "").replace(/\/$/, "");
    return `${base}${value.startsWith("/") ? value : `/${value}`}`;
};

const avatarFileUrl = (email) => {
    const id = String(email || "").trim().toLowerCase();
    return id ? resolveAvatarUrl(`/access/avatar-file?email=${encodeURIComponent(id)}`) : "";
};

const useAvatarSrc = (email, fallback = {}) => {
    const me = useAuthStore((state) => state.email);
    const myUrl = useSettingsStore((state) => state.avatarUrl);
    const myKey = useSettingsStore((state) => state.avatarKey);
    const myColor = useSettingsStore((state) => state.avatarBg);
    const mine = sameUser(email, me);
    const { data } = useQuery({
        queryKey: ["avatar-url", String(email || "").toLowerCase()],
        queryFn: () => fetchAvatarUrl(email),
        enabled: Boolean(email) && !mine && fallback.src == null && fallback.color == null,
        staleTime: 5 * 60 * 1000,
    });

    if (mine) {
        return {
            src: myKey || myUrl || fallback.src ? avatarFileUrl(me) : "",
            color: myColor || fallback.color || DEFAULT_AVATAR_BG,
        };
    }

    const hasPhoto = Boolean(fallback.src || fallback.key || data?.avatarKey || data?.url);
    return {
        src: hasPhoto ? avatarFileUrl(email) : "",
        color: fallback.color || data?.color || DEFAULT_AVATAR_BG,
    };
};

export { avatarFileUrl, resolveAvatarUrl, sameUser, useAvatarSrc };
